

export const linkReducer = (state = { link: '', finalLink: '' }, action) => {
    switch (action.type) {

        case 'SET_LINK':
            return { link: action.payload }
        case 'SET_FINAL_LINK':
            return { finalLink: action.payload }
        default:
            return state
    }

}